// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__o8Wjh","selected":"styles_selected__3LcVI"};